import React from 'react';
import { Box, Flex, HStack, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { unique } from '../../../../../utils/arrayUtil';
import { getDateString, isPast } from '../../../../../utils/dateUtil';
import { getStatusDisplayName } from '../../../../../utils/statusUtil';

function mapValue(value) {
  if (Number(value) > 1) return `$${Number(parseInt(value, 10).toFixed(1)).toLocaleString()}`;
  if (Number(value) === 1) return 'On';
  return value;
}

const PolicyCell = ({ value: { data: itemsOrInsureds } }) => {
  const policies = itemsOrInsureds.reduce((pols, item) => ([...pols, ...(item.insurancePolicies || [])]), []);

  return (
    <VStack fontSize="sm" maxH={300} overflow="auto">
      {unique(policies, p => p.id).map(policy => (
        <Popover
          key={policy.id}
          placement="top-start"
          trigger="hover"
        >
          <PopoverTrigger>
            <HStack cursor="pointer" key={policy.id} minWidth={300} width="100%">
              <Box
                flexBasis="50%"
                textAlign="right"
                whiteSpace="nowrap"
              >
                {policy.type.displayName}
              </Box>
              <Box
                color={isPast(policy.expiresAt) ? 'red' : 'inherit'}
                flexBasis="50%"
                textAlign="left"
                whiteSpace="nowrap"
              >
                {getDateString(policy.expiresAt, 'MM/DD/YYYY')}
              </Box>

            </HStack>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverArrow />
            <PopoverBody p={3}>
              <Flex justifyContent="space-between" width="100%">
                <Box fontSize="sm" mr={3} whiteSpace="nowrap">Status</Box>
                <Box color="grey" fontSize="sm" whiteSpace="nowrap">{getStatusDisplayName(policy.status)}</Box>
              </Flex>
              { policy.properties.map(({ name, displayName, value }) => (
                <Flex justifyContent="space-between" key={`${name}-${value}`} width="100%">
                  <Box fontSize="sm" mr={3} whiteSpace="nowrap">{displayName}</Box>
                  <Box color="grey" fontSize="sm" whiteSpace="nowrap">{mapValue(value)}</Box>
                </Flex>
              ))}
            </PopoverBody>
          </PopoverContent>
        </Popover>
      ))}
    </VStack>
  );
};

PolicyCell.propTypes = {
  value: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({
      properties: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string,
        value: PropTypes.string
      }))
    }))
  })
};

export default PolicyCell;
